import { Injectable } from '@angular/core';
import { StorageKeyEnum } from '../storage/storageKeyEnum.enum';

@Injectable()
export class SessionService {
  constructor() {}
  setItem(key: StorageKeyEnum, value: any): void {
    localStorage.setItem('carrier-'+key.toString(), value);
  }
  getItem(key: StorageKeyEnum): any {
    return localStorage.getItem('carrier-'+key.toString());
  }
  removeItem(key: StorageKeyEnum): void {
    localStorage.removeItem('carrier-'+key.toString());
  }
  clear(): void {
    // localStorage.clear();
    // Iterar sobre las claves y eliminar las que comiencen con "carrier-"
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith('carrier-')) {
        localStorage.removeItem(key);
      }
    });
  }
}
